/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_TranscribingInputs */



/**
* | output |
* | --- |
* | "Transcribing media..." |
*
* @param {Offline_Sync_Status_TranscribingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_transcribing = /** @type {((inputs?: Offline_Sync_Status_TranscribingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_TranscribingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription du média...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien werden transkribiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione media in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Транскрибация медиа...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcribiendo medios...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在转写媒体...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアを文字起こししています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया ट्रांसक्राइब हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A transcrever multimédia...")
	return /** @type {LocalizedString} */ ("Transcribing media...")
});